export const TERM_DATA = [

    { name: "Autumn Term 1 2022", from: new Date("2022-09-05"), to: new Date("2022-10-21") },
    { name: "October Half Term 2022", from: new Date("2022-10-24"), to: new Date("2022-10-28") },
    { name: "Autumn Term 2 2022", from: new Date("2022-10-31"), to: new Date("2022-12-16") },

    { name: "Festive Holidays 2022", from: new Date("2022-12-19"), to: new Date("2023-01-02") },

    { name: "Spring Term 1 2023", from: new Date("2023-01-03"), to: new Date("2023-02-17") },
    { name: "February Half Term 2023", from: new Date("2023-02-20"), to: new Date("2023-02-24") },
    { name: "Spring Term 2 2023", from: new Date("2023-02-27"), to: new Date("2023-03-31") },

    { name: "Easter Holidays 2023", from: new Date("2023-04-03"), to: new Date("2023-04-14") },

    { name: "Summer Term 1 2023", from: new Date("2023-04-17"), to: new Date("2023-05-26") },
    { name: "May Half Term 2023", from: new Date("2023-05-29"), to: new Date("2023-06-02") },
    { name: "Summer Term 2 2023", from: new Date("2023-06-05"), to: new Date("2023-07-25") },




    { name: "Summer Holidays 2023", from: new Date("2023-07-26"), to: new Date("2023-09-01")},

    { name: "Autumn Term 1 2023", from: new Date("2023-09-04"), to: new Date("2023-10-27") },
    { name: "October Half Term 2023", from: new Date("2023-10-30"), to: new Date("2023-11-03") },
    { name: "Autumn Term 2 2023", from: new Date("2023-11-06"), to: new Date("2023-12-22") },

    { name: "Festive Holidays 2023", from: new Date("2023-12-25"), to: new Date("2024-01-05") },

    { name: "Spring Term 1 2024", from: new Date("2024-01-08"), to: new Date("2024-02-09") },
    { name: "February Half Term 2024", from: new Date("2024-02-12"), to: new Date("2024-02-16") },
    { name: "Spring Term 2 2024", from: new Date("2024-02-19"), to: new Date("2024-03-22") },

    { name: "Easter Holidays 2024", from: new Date("2024-03-25"), to: new Date("2024-04-05") },

    { name: "Summer Term 1 2024", from: new Date("2024-04-08"), to: new Date("2024-05-24") },
    { name: "May Half Term 2024", from: new Date("2024-05-27"), to: new Date("2024-05-31") },
    { name: "Summer Term 2 2024", from: new Date("2024-06-03"), to: new Date("2024-07-22") },



 
    { name: "Summer Holidays 2024", from: new Date("2024-07-23"), to: new Date("2024-08-31")},

    { name: "Autumn Term 1 2024", from: new Date("2024-09-02"), to: new Date("2024-10-25") },
    { name: "October Half Term 2024", from: new Date("2024-10-28"), to: new Date("2024-11-01") },
    { name: "Autumn Term 2 2024", from: new Date("2024-11-04"), to: new Date("2024-12-20") },

    { name: "Festive Holidays 2024", from: new Date("2024-12-23"), to: new Date("2025-01-03") },

    { name: "Spring Term 1 2025", from: new Date("2025-01-06"), to: new Date("2025-02-14") },
    { name: "February Half Term 2025", from: new Date("2025-02-17"), to: new Date("2025-02-21") },
    { name: "Spring Term 2 2025", from: new Date("2025-02-24"), to: new Date("2025-04-11") },

    { name: "Easter Holidays 2025", from: new Date("2025-04-14"), to: new Date("2025-04-25") },

    { name: "Summer Term 1 2025", from: new Date("2025-04-28"), to: new Date("2025-05-23") },
    { name: "May Half Term 2025", from: new Date("2025-05-26"), to: new Date("2025-05-30") },
    { name: "Summer Term 2 2025", from: new Date("2025-06-02"), to: new Date("2025-07-21") },



    { name: "Summer Holidays 2025", from: new Date("2025-07-22"), to: new Date("2025-08-29") },

    { name: "Autumn Term 1 2025", from: new Date("2025-09-01"), to: new Date("2025-10-24") },
    { name: "October Half Term 2025", from: new Date("2025-10-27"), to: new Date("2025-10-31") },
    { name: "Autumn Term 2 2025", from: new Date("2025-11-03"), to: new Date("2025-12-19") },
   
    { name: "Festive Holidays 2025", from: new Date("2025-12-22"), to: new Date("2026-01-02") },
   
    { name: "Spring Term 1 2026", from: new Date("2026-01-05"), to: new Date("2026-02-13") },
    { name: "February Half Term 2026", from: new Date("2026-02-16"), to: new Date("2026-02-20") },
    { name: "Spring Term 2 2026", from: new Date("2026-02-23"), to: new Date("2026-03-27") },
   
    { name: "Easter Holidays 2026", from: new Date("2026-03-30"), to: new Date("2026-04-10") },
   
    { name: "Summer Term 1 2026", from: new Date("2026-04-13"), to: new Date("2026-05-22") },
    { name: "May Half Term 2026", from: new Date("2026-05-25"), to: new Date("2026-05-29") },
    { name: "Summer Term 2 2026", from: new Date("2026-06-01"), to: new Date("2026-07-20") }

];


// WEBPACK FOOTER //
// ./termData.js